module.exports = ".dm-header-hotlink {\r\n    height: 52px;\r\n    width: 124px;\r\n    position: absolute;\r\n    left: 0px;\r\n    top: 30px;\r\n    z-index: 9999999;\r\n}\r\n\r\n\r\n.header-links-left a {\r\n    margin-left: 8px;   \r\n}\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/header/header.component.css
// module id = ./src/app/shared/header/header.component.css
// module chunks = main